import { render } from "./LoadingScreenSection.vue?vue&type=template&id=e1880734&scoped=true"
import script from "./LoadingScreenSection.vue?vue&type=script&lang=js"
export * from "./LoadingScreenSection.vue?vue&type=script&lang=js"

import "./LoadingScreenSection.vue?vue&type=style&index=0&id=e1880734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1880734"]])

export default __exports__